module.exports = __webpack_public_path__ + "static/media/testimonial-christine.6b96b305.png";